
export const footerHtml = `<center class="wrapper" data-link-color="#1188E6" data-body-style="font-size:14px; font-family:arial,helvetica,sans-serif; color:#000000; background-color:#FFFFFF;">
<div class="webkit">
  <table cellpadding="0" cellspacing="0" border="0" width="100%" class="wrapper" bgcolor="#FFFFFF">
    <tr>
      <td valign="top" bgcolor="#FFFFFF" width="100%">
        <table width="100%" role="content-container" class="outer" align="center" cellpadding="0" cellspacing="0" border="0">
          <tr>
            <td width="100%">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td>
                        <!--[if mso]>
<center>
<table><tr><td width="600">
<![endif]-->
<table width="100%" cellpadding="0" cellspacing="0" border="0" style="width:100%; max-width:600px;" align="center">
  <tr>
    <td role="modules-container" style="padding:0px 0px 0px 0px; color:#000000; text-align:left;" bgcolor="#FFFFFF" width="100%" align="left">
    <table class="module preheader preheader-hide" role="module" data-type="preheader" border="0" cellpadding="0" cellspacing="0" width="100%" style="display: none !important; mso-hide: all; visibility: hidden; opacity: 0; color: transparent; height: 0; width: 0;">
      <tr>
        <td role="module-content">
          <p></p>
        </td>
      </tr>
    </table>

      <table class="module" role="module" data-type="divider" border="0" cellpadding="0" cellspacing="0" width="100%" style="table-layout: fixed;" data-muid="39d82e8f-d361-42e6-b0ac-d2578439ade0">
        <tbody>
          <tr>
            <td style="padding:0px 0px 0px 0px;" role="module-content" height="100%" valign="top" bgcolor="">
              <table border="0" cellpadding="0" cellspacing="0" align="center" width="100%" height="2px" style="line-height:2px; font-size:2px;">
                <tbody>
                  <tr>
                    <td style="padding:0px 0px 2px 0px;" bgcolor="#000000"></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <table border="0" cellpadding="0" cellspacing="0" align="center" width="100%" role="module" data-type="columns" style="padding:0px 0px 0px 0px;" bgcolor="#FFFFFF">
        <tbody>
          <tr role="module-content">
            <td height="100%" valign="top"><table width="290" style="width:290px; border-spacing:0; border-collapse:collapse; margin:0px 10px 0px 0px;" cellpadding="0" cellspacing="0" align="left" border="0" bgcolor="" class="column column-0">
              <tbody>
                <tr>
                  <td style="padding:0px;margin:0px;border-spacing:0;"><table class="wrapper" role="module" data-type="image" border="0" cellpadding="0" cellspacing="0" width="100%" style="table-layout: fixed;" data-muid="9JoWuoJSQgG6849iciYauZ">
                    <tbody>
                      <tr>
                        <td style="font-size:6px; line-height:10px; padding:0px 0px 0px 0px;" valign="top" align="center">
                          <img class="max-width" border="0" style="display:block; color:#000000; text-decoration:none; font-family:Helvetica, arial, sans-serif; font-size:16px;" width="200" alt="Lotusdew Wealth" data-proportionally-constrained="true" data-responsive="false" src="http://cdn.mcauto-images-production.sendgrid.net/c13d7d0359a63536/f8e506d1-ae00-4117-b6c8-2140721aeea7/200x200.png" height="200">
                        </td>
                      </tr>
                    </tbody>
                  </table></td>
                </tr>
              </tbody>
            </table>
            <table width="290" style="width:290px; border-spacing:0; border-collapse:collapse; margin:0px 0px 0px 10px;" cellpadding="0" cellspacing="0" align="left" border="0" bgcolor="" class="column column-1">
              <tbody>
                <tr>
                  <td style="padding:0px;margin:0px;border-spacing:0;"><table class="module" role="module" data-type="text" border="0" cellpadding="0" cellspacing="0" width="100%" style="table-layout: fixed;" data-muid="fTHE9ot73ah23atSDP5WQf" data-mc-module-version="2019-10-22">
                    <tbody>
                      <tr>
                        <td style="padding:18px 0px 18px 0px; line-height:22px; text-align:inherit;" height="100%" valign="top" bgcolor="" role="module-content"><div><div style="font-family: inherit; text-align: inherit"><span style="font-size: 12px; color: #000000">LotusDew Wealth and Investment Advisors<br>
                        Plot no 4,&nbsp;</span></div>
                        <div style="font-family: inherit; text-align: inherit"><span style="font-size: 12px; color: #000000">Taranagar Colony, Serilingampally<br>
                          Hyderabad 500 019<br>
                          <br>
                          Call us: 1800 572 3851<br>
                          <br>
                          SEBI: INA200013770<br>
                        GST: 36AADCL9280F1ZB</span></div><div></div></div></td>
                      </tr>
                    </tbody>
                  </table></td>
                </tr>
              </tbody>
            </table>
          </td>
          </tr>
        </tbody>
      </table>
      <table class="module" role="module" data-type="social" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="table-layout: fixed;" data-muid="44b9a846-f309-4ef5-9176-9ad8832dbf02">
        <tbody>
          <tr>
            <td valign="top" style="padding:0px 0px 0px 0px; font-size:6px; line-height:10px;" align="right">
              <table align="right" style="-webkit-margin-start:auto;-webkit-margin-end:auto;">
                <tbody><tr align="right"><td style="padding: 0px 5px;" class="social-icon-column">
                  <a role="social-icon-link" href="https://www.facebook.com/lotusdewhq/" target="_blank" alt="Facebook" title="Facebook" style="display:inline-block; background-color:#3B579D; height:21px; width:21px;">
                    <img role="social-icon" alt="Facebook" title="Facebook" src="https://marketing-image-production.s3.amazonaws.com/social/white/facebook.png" style="height:21px; width:21px;" height="21" width="21">
                  </a>
                </td><td style="padding: 0px 5px;" class="social-icon-column">
                  <a role="social-icon-link" href="https://twitter.com/lotusdewhq" target="_blank" alt="Twitter" title="Twitter" style="display:inline-block; background-color:#7AC4F7; height:21px; width:21px;">
                    <img role="social-icon" alt="Twitter" title="Twitter" src="https://marketing-image-production.s3.amazonaws.com/social/white/twitter.png" style="height:21px; width:21px;" height="21" width="21">
                  </a>
                </td><td style="padding: 0px 5px;" class="social-icon-column">
                  <a role="social-icon-link" href="https://www.linkedin.com/company/lotusdew" target="_blank" alt="LinkedIn" title="LinkedIn" style="display:inline-block; background-color:#0077B5; height:21px; width:21px;">
                    <img role="social-icon" alt="LinkedIn" title="LinkedIn" src="https://marketing-image-production.s3.amazonaws.com/social/white/linkedin.png" style="height:21px; width:21px;" height="21" width="21">
                  </a>
                </td></tr></tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <div data-role="module-unsubscribe" class="module" role="module" data-type="unsubscribe" style="color:#444444; font-size:12px; line-height:20px; padding:16px 16px 16px 16px; text-align:Center;" data-muid="4e838cf3-9892-4a6d-94d6-170e474d21e5"><div class="Unsubscribe--addressLine"></div><p style="font-size:12px; line-height:20px;"><a class="Unsubscribe--unsubscribeLink" href="{{{unsubscribe}}}" target="_blank" style="">Unsubscribe</a></p></div></td>
    </tr>
  </table>
                                <!--[if mso]>
                              </td>
                            </tr>
                          </table>
                        </center>
                      <![endif]-->
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>
</center>`;

export const buttonHtml = `<table border="0" cellpadding="0" cellspacing="0" class="module" data-role="module-button" data-type="button" role="module" style="table-layout:fixed;" width="100%" data-muid="e391aad4-2560-4d47-ac68-144d2aedceb3">
<tbody>
  <tr>
    <td align="center" bgcolor="" class="outer-td" style="padding:0px 0px 0px 0px;">
      <table border="0" cellpadding="0" cellspacing="0" class="wrapper-mobile" style="text-align:center;">
        <tbody>
          <tr>
          <td align="center" bgcolor="#24a557" class="inner-td" style="border-radius:6px; font-size:16px; text-align:center; background-color:inherit;">
            <a href="https://chat.whatsapp.com/JIh89zGYuRx1C2ePGbLFku" style="background-color:#24a557; border:1px solid #ffffff; border-color:#ffffff; border-radius:6px; border-width:1px; color:#ffffff; display:inline-block; font-size:14px; font-weight:normal; letter-spacing:0px; line-height:normal; padding:12px 18px 12px 18px; text-align:center; text-decoration:none; border-style:solid; font-family:trebuchet ms,helvetica,sans-serif;" target="_blank">Join Whatsapp Group</a>
          </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</tbody>
</table>`;



export const getHtmlElement = (mainELe, footerHtml) => {
  return `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
  <html data-editor-version="2" class="sg-campaigns" xmlns="http://www.w3.org/1999/xhtml">
      <head>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1">
        <!--[if !mso]><!-->
        <meta http-equiv="X-UA-Compatible" content="IE=Edge">
        <!--<![endif]-->
        <!--[if (gte mso 9)|(IE)]>
        <xml>
          <o:OfficeDocumentSettings>
            <o:AllowPNG/>
            <o:PixelsPerInch>96</o:PixelsPerInch>
          </o:OfficeDocumentSettings>
        </xml>
        <![endif]-->
        <!--[if (gte mso 9)|(IE)]>
    <style type="text/css">
      body {width: 600px;margin: 0 auto;}
      table {border-collapse: collapse;}
      table, td {mso-table-lspace: 0pt;mso-table-rspace: 0pt;}
      img {-ms-interpolation-mode: bicubic;}
    </style>
  <![endif]-->
        <style type="text/css">
      body, p, div {
        font-family: arial,helvetica,sans-serif;
        font-size: 14px;
      }
      body {
        color: #000000;
      }
      body a {
        color: #1188E6;
        text-decoration: none;
      }
      p { margin: 0; padding: 0; }
      table.wrapper {
        width:100% !important;
        table-layout: fixed;
        -webkit-font-smoothing: antialiased;
        -webkit-text-size-adjust: 100%;
        -moz-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
      }
      img.max-width {
        max-width: 100% !important;
      }
      .column.of-2 {
        width: 50%;
      }
      .column.of-3 {
        width: 33.333%;
      }
      .column.of-4 {
        width: 25%;
      }
      @media screen and (max-width:480px) {
        .preheader .rightColumnContent,
        .footer .rightColumnContent {
          text-align: left !important;
        }
        .preheader .rightColumnContent div,
        .preheader .rightColumnContent span,
        .footer .rightColumnContent div,
        .footer .rightColumnContent span {
          text-align: left !important;
        }
        .preheader .rightColumnContent,
        .preheader .leftColumnContent {
          font-size: 80% !important;
          padding: 5px 0;
        }
        table.wrapper-mobile {
          width: 100% !important;
          table-layout: fixed;
        }
        img.max-width {
          height: auto !important;
          max-width: 100% !important;
        }
        a.bulletproof-button {
          display: block !important;
          width: auto !important;
          font-size: 80%;
          padding-left: 0 !important;
          padding-right: 0 !important;
        }
        .columns {
          width: 100% !important;
        }
        .column {
          display: block !important;
          width: 100% !important;
          padding-left: 0 !important;
          padding-right: 0 !important;
          margin-left: 0 !important;
          margin-right: 0 !important;
        }
        .social-icon-column {
          display: inline-block !important;
        }
      }
    </style>
      
      </head>
      <body>
      <center class="wrapper" data-link-color="#1188E6" data-body-style="font-size:14px; font-family:arial,helvetica,sans-serif; color:#000000; background-color:#FFFFFF;">
      <div class="webkit">
        <table cellpadding="0" cellspacing="0" border="0" width="100%" class="wrapper" bgcolor="#FFFFFF">
          <tr>
            <td valign="top" bgcolor="#FFFFFF" width="100%">
              <table width="100%" role="content-container" class="outer" align="center" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td width="100%">
                    <table width="100%" cellpadding="0" cellspacing="0" border="0">
                      <tr>
                        <td>
       
      <table width="100%" cellpadding="0" cellspacing="0" border="0" style="width:100%; max-width:600px;" align="center">
        <tr>
          <td role="modules-container" style="padding:0px 0px 0px 0px; color:#000000; text-align:left;" bgcolor="#FFFFFF" width="100%" align="left">
          <table class="module preheader preheader-hide" role="module" data-type="preheader" border="0" cellpadding="0" cellspacing="0" width="100%" style="display: none !important; mso-hide: all; visibility: hidden; opacity: 0; color: transparent; height: 0; width: 0;">
            <tr>
              <td role="module-content">
                <p></p>
              </td>
            </tr>
          </table>
            ${mainELe}
            <table class="module" role="module" data-type="divider" border="0" cellpadding="0" cellspacing="0" width="100%" style="table-layout: fixed;" data-muid="39d82e8f-d361-42e6-b0ac-d2578439ade0">
              <tbody>
                <tr>
                  <td style="padding:0px 0px 0px 0px;" role="module-content" height="100%" valign="top" bgcolor="">
                    <table border="0" cellpadding="0" cellspacing="0" align="center" width="100%" height="2px" style="line-height:2px; font-size:2px;">
                      <tbody>
                        <tr>
                          <td style="padding:0px 0px 2px 0px;" bgcolor="#000000"></td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            <table border="0" cellpadding="0" cellspacing="0" align="center" width="100%" role="module" data-type="columns" style="padding:0px 0px 0px 0px;" bgcolor="#FFFFFF">
              <tbody>
                <tr role="module-content">
                  <td height="100%" valign="top"><table width="290" style="width:290px; border-spacing:0; border-collapse:collapse; margin:0px 10px 0px 0px;" cellpadding="0" cellspacing="0" align="left" border="0" bgcolor="" class="column column-0">
                    <tbody>
                      <tr>
                        <td style="padding:0px;margin:0px;border-spacing:0;"><table class="wrapper" role="module" data-type="image" border="0" cellpadding="0" cellspacing="0" width="100%" style="table-layout: fixed;" data-muid="9JoWuoJSQgG6849iciYauZ">
                          <tbody>
                            <tr>
                              <td style="font-size:6px; line-height:10px; padding:0px 0px 0px 0px;" valign="top" align="center">
                                <img class="max-width" border="0" style="display:block; color:#000000; text-decoration:none; font-family:Helvetica, arial, sans-serif; font-size:16px;" width="200" alt="Lotusdew Wealth" data-proportionally-constrained="true" data-responsive="false" src="http://cdn.mcauto-images-production.sendgrid.net/c13d7d0359a63536/f8e506d1-ae00-4117-b6c8-2140721aeea7/200x200.png" height="200">
                              </td>
                            </tr>
                          </tbody>
                        </table></td>
                      </tr>
                    </tbody>
                  </table>
                  <table width="290" style="width:290px; border-spacing:0; border-collapse:collapse; margin:0px 0px 0px 10px;" cellpadding="0" cellspacing="0" align="left" border="0" bgcolor="" class="column column-1">
                    <tbody>
                      <tr>
                        <td style="padding:0px;margin:0px;border-spacing:0;"><table class="module" role="module" data-type="text" border="0" cellpadding="0" cellspacing="0" width="100%" style="table-layout: fixed;" data-muid="fTHE9ot73ah23atSDP5WQf" data-mc-module-version="2019-10-22">
                          <tbody>
                            <tr>
                              <td style="padding:18px 0px 18px 0px; line-height:22px; text-align:inherit;" height="100%" valign="top" bgcolor="" role="module-content"><div><div style="font-family: inherit; text-align: inherit"><span style="font-size: 12px; color: #000000">LotusDew Wealth and Investment Advisors<br>
                              Plot no 4,&nbsp;</span></div>
                              <div style="font-family: inherit; text-align: inherit"><span style="font-size: 12px; color: #000000">Taranagar Colony, Serilingampally<br>
                                Hyderabad 500 019<br>
                                <br>
                                Call us: 1800 572 3851<br>
                                <br>
                                SEBI: INA200013770<br>
                              GST: 36AADCL9280F1ZB</span></div><div></div></div></td>
                            </tr>
                          </tbody>
                        </table></td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                </tr>
              </tbody>
            </table>
            <table class="module" role="module" data-type="social" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="table-layout: fixed;" data-muid="44b9a846-f309-4ef5-9176-9ad8832dbf02">
              <tbody>
                <tr>
                  <td valign="top" style="padding:0px 0px 0px 0px; font-size:6px; line-height:10px;" align="right">
                    <table align="right" style="-webkit-margin-start:auto;-webkit-margin-end:auto;">
                      <tbody><tr align="right"><td style="padding: 0px 5px;" class="social-icon-column">
                        <a role="social-icon-link" href="https://www.facebook.com/lotusdewhq/" target="_blank" alt="Facebook" title="Facebook" style="display:inline-block; background-color:#3B579D; height:21px; width:21px;">
                          <img role="social-icon" alt="Facebook" title="Facebook" src="https://marketing-image-production.s3.amazonaws.com/social/white/facebook.png" style="height:21px; width:21px;" height="21" width="21">
                        </a>
                      </td><td style="padding: 0px 5px;" class="social-icon-column">
                        <a role="social-icon-link" href="https://twitter.com/lotusdewhq" target="_blank" alt="Twitter" title="Twitter" style="display:inline-block; background-color:#7AC4F7; height:21px; width:21px;">
                          <img role="social-icon" alt="Twitter" title="Twitter" src="https://marketing-image-production.s3.amazonaws.com/social/white/twitter.png" style="height:21px; width:21px;" height="21" width="21">
                        </a>
                      </td><td style="padding: 0px 5px;" class="social-icon-column">
                        <a role="social-icon-link" href="https://www.linkedin.com/company/lotusdew" target="_blank" alt="LinkedIn" title="LinkedIn" style="display:inline-block; background-color:#0077B5; height:21px; width:21px;">
                          <img role="social-icon" alt="LinkedIn" title="LinkedIn" src="https://marketing-image-production.s3.amazonaws.com/social/white/linkedin.png" style="height:21px; width:21px;" height="21" width="21">
                        </a>
                      </td></tr></tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            <div data-role="module-unsubscribe" class="module" role="module" data-type="unsubscribe" style="color:#444444; font-size:12px; line-height:20px; padding:16px 16px 16px 16px; text-align:Center;" data-muid="4e838cf3-9892-4a6d-94d6-170e474d21e5"><div class="Unsubscribe--addressLine"></div><p style="font-size:12px; line-height:20px;"><a class="Unsubscribe--unsubscribeLink" href="{{{unsubscribe}}}" target="_blank" style="">Unsubscribe</a></p></div></td>
          </tr>
        </table>
                                      <!--[if mso]>
                                    </td>
                                  </tr>
                                </table>
                              </center>
                            <![endif]-->
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </center></body></html>`
}

// export const getEditor =(name) => {
//   return name;
// }

export const blogFooter = `       
<h2 classname="check-out" style="
font-size: 20px;
">Check our Listed Venture Capital portfolio on <a href="https://lotusdew.smallcase.com/" target="_blank" rel="noopener noreferrer" style="
color: #32B265;
text-decoration: none;
">https://lotusdew.smallcase.com/</a></h2>
<p style="
font-size: 20px;
color: #757575;
font-family: &quot;FreightSansProBook-Regular&quot;;
">Follow us on twitter: <a href="https://twitter.com/LotusDewHQ" target="_blank" rel="noopener noreferrer" style="
text-decoration: none;
"><span style="
color: #32B265;
">https://twitter.com/LotusDewHQ</span></a></p>         
<p style="
font-size: 20px;
color: #757575;
font-family: &quot;FreightSansProBook-Regular&quot;;
">How to proceed:</p>
<p style="
font-size: 20px;
color: #757575;
font-family: &quot;FreightSansProBook-Regular&quot;;
">Email me back if you are interested so that I can guide you.</p>
<p style="
font-size: 20px;
color: #757575;
font-family: &quot;FreightSansProBook-Regular&quot;;
">If you already have an account with HDFC, Kotak, IIFL, Axis, Edelweiss you can directly subscribe on <a href="https://lotusdew.smallcase.com/" target="_blank" rel="noopener noreferrer" style="
color: #32B265;
text-decoration: none;
">https://lotusdew.smallcase.com/</a></p>
<blockquote style="
color: #545454;
font-size: 21px;
line-height: 180%;
font-style: italic;
margin-left: 55px;
padding-left: 20px;
position: relative;
border-left: 5px solid #cccccc;
margin: 0 0 1rem;
">If you want to open a new brokerage account – I can help you with that as well.<cite>Abrams</cite></blockquote>`;